import React, { useState } from "react";
import { PLANS } from "../styles/tokens";
import PlanButton from "./PlanButton";
import { useTilt } from "../lib/motion";

function PricingCard(props) {
  var p = props.p;
  var [isHov, setIsHov] = useState(false);
  var tiltRef = useTilt({ maxTilt: 7 });

  return (
    <div
      ref={tiltRef}
      onMouseEnter={function() { setIsHov(true); }}
      onMouseLeave={function() { setIsHov(false); }}
      style={{
        background: "#fefcfa", border: "1.5px solid rgba(180,160,140,0.35)",
        borderRadius: 20, padding: "30px 28px", position: "relative",
        display: "flex", flexDirection: "column",
        boxShadow: isHov ? "0 16px 48px rgba(44,36,32,.16)" : "0 2px 8px rgba(44,36,32,.04)",
        transition: "box-shadow 0.28s cubic-bezier(0.34,1.2,0.64,1)",
      }}
    >
      <div style={{ display: "inline-block", fontSize: 9, letterSpacing: 2.5, padding: "4px 12px", borderRadius: 100, marginBottom: 18, fontWeight: 700, color: p.color, background: p.color + "18", border: "1px solid " + p.color + "44", alignSelf: "flex-start" }}>{p.badge}</div>
      {p.comingSoon && (
        <div style={{ display: "inline-block", fontSize: 9, letterSpacing: 2, padding: "3px 10px", borderRadius: 100, marginBottom: 18, marginLeft: 6, fontWeight: 700, color: "#7a6e64", background: "rgba(180,160,140,.12)", border: "1px solid rgba(180,160,140,.3)", alignSelf: "flex-start" }}>🔜 SOME FEATURES COMING SOON</div>
      )}
      <div style={{ fontFamily: "Georgia,serif", fontSize: 22, fontWeight: 500, marginBottom: 8, color: "#2c2420" }}>{p.name}</div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 3, marginBottom: 4 }}>
        <span style={{ fontSize: 16, color: "#7a6e64", marginTop: 6 }}>$</span>
        <span style={{ fontFamily: "Georgia,serif", fontSize: 52, fontWeight: 500, color: p.color, lineHeight: 1 }}>{p.price}</span>
        <span style={{ fontSize: 12, color: "#7a6e64" }}>{p.per}</span>
      </div>
      <div style={{ fontSize: 10, color: "#7a6e64", marginBottom: 24, letterSpacing: 1 }}>{p.note}</div>
      <hr style={{ border: "none", borderTop: "1px solid rgba(180,160,140,.16)", marginBottom: 20 }} />
      <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 11, marginBottom: 28, flex: 1 }}>
        {p.feats.map(function(f) {
          return (
            <li key={f} style={{ display: "flex", alignItems: "flex-start", gap: 9, fontSize: 13, color: "#4a3f38", lineHeight: 1.5 }}>
              <span style={{ color: p.color, flexShrink: 0, fontWeight: 700, marginTop: 1 }}>✓</span>{f}
            </li>
          );
        })}
      </ul>
      {p.comingSoon ? (
        <div style={{ width: "100%", padding: "13px 0", borderRadius: 100, fontFamily: "inherit", fontWeight: 700, fontSize: 12, letterSpacing: 1.5, border: "1.5px dashed " + p.color + "66", background: p.color + "08", color: p.color + "99", textAlign: "center", marginTop: "auto" }}>
          🔜 Coming Soon
        </div>
      ) : (
        <PlanButton plan={p} user={props.user} onNeedAuth={props.onNeedAuth} />
      )}
    </div>
  );
}

export default function PricingCards(props) {
  return (
    <div className="plan-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 20, marginBottom: 60, alignItems: "stretch" }}>
      {PLANS.map(function(p) {
        return <PricingCard key={p.name} p={p} user={props.user} onNeedAuth={props.onNeedAuth} />;
      })}
    </div>
  );
}
